import React, { useState, useEffect } from "react";
import "./Stats.css";

const Stats = () => {
  const [counters, setCounters] = useState(["3+", "18+", "1200+"]);

  const handleHover = (index, targetNumber) => {
    let count = 0;
    const increment = Math.ceil(targetNumber / 50); // Adjust the increment for a smoother animation
    const interval = setInterval(() => {
      count += increment;
      if (count >= targetNumber) {
        count = targetNumber;
        clearInterval(interval);
      }
      const newCounters = [...counters];
      newCounters[index] = `${count}+`;
      setCounters(newCounters);
    }, 20); // Adjust the interval for a smoother animation
  };

  // Reset counters to "+" when component unmounts
  useEffect(() => {
    return () => {
      setCounters(["3+", "18+", "1200+"]);
    };
  }, []);

  return (
    <>
      <section className="stats" id="stats">
        <ul className="stats-list">
          <li>
            <button
              type="button"
              className="stats-card"
              onMouseEnter={() => handleHover(0, 3)}
            >
              <div className="card-icon">
                <img
                  src="./assets/images/stats-card_icon-1.png"
                  alt="Badge icon"
                />
              </div>

              <h2 className="h2 card-title">
                {counters[0]} <strong>Years of Experience</strong>
              </h2>

              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </li>

          <li>
            <button
              type="button"
              className="stats-card"
              onMouseEnter={() => handleHover(1, 12)}
            >
              <div className="card-icon">
                <img
                  src="./assets/images/stats-card_icon-2.png"
                  alt="Checkmark icon"
                />
              </div>

              <h2 className="h2 card-title">
                {counters[1]} <strong>Completed Projects</strong>
              </h2>

              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </li>

          <li>
            <button
              type="button"
              className="stats-card"
              onMouseEnter={() => handleHover(2, 800)}
            >
              <div className="card-icon">
                <img
                  src="./assets/images/stats-card_icon-3.png"
                  alt="Peoples rating icon"
                />
              </div>

              <h2 className="h2 card-title">
                {counters[2]} <strong>Hours Coded</strong>
              </h2>

              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </li>
        </ul>
      </section>
    </>
  );
};

export default Stats;
